module.exports = __webpack_public_path__ + "static/inwestycja-6fa18053c9d8567507eb87124177e5ff.jpg";